<template>
  <div class="right">
    <div class="title-body">
      <div class="title-body-title">
        保险公司合作信息
        <div
          style="
            flex: 1;
            height: 4px;
            margin-top: 18px;
            margin-left: 10px;
            background-image: url(./static/img/bar.png);
          "
        ></div>
      </div>
    </div>
    <div class="infomation">
      <!--内容开始-->
      <div >
        <h3  style="margin: 20px 0px 10px">
          1、经营互联网保险业务的网站
        </h3>
        <div
          class="tableList"
          displaytitle=""
        >
          <div
            class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition"
          >
            <div class="hidden-columns">
              <div ></div>
              <div ></div>
              <div ></div>
              <div ></div>
              <div ></div>
            </div>
            <div class="el-table__header-wrapper">
              <table
                cellspacing="0"
                cellpadding="0"
                border="0"
                class="el-table__header"
                style="width: 994px"
              >
                <colgroup>
                  <col name="el-table_40_column_155" width="80" />
                  <col name="el-table_40_column_157" width="230" />
                  <col name="el-table_40_column_158" width="228" />
                  <col name="el-table_40_column_159" width="228" />
                  <col name="el-table_40_column_160" width="228" />
                  <col name="gutter" width="0" />
                </colgroup>
                <thead class="has-gutter">
                  <tr class="">
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_40_column_155 is-center is-leaf"
                      style="
                        background-color: rgb(241, 241, 241);
                        font-size: 16px;
                        font-weight: bold;
                        color: rgb(51, 51, 51);
                      "
                    >
                      <div class="cell">序号</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_40_column_157 is-center is-leaf"
                      style="
                        background-color: rgb(241, 241, 241);
                        font-size: 16px;
                        font-weight: bold;
                        color: rgb(51, 51, 51);
                      "
                    >
                      <div class="cell">合作平台</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_40_column_158 is-center is-leaf"
                      style="
                        background-color: rgb(241, 241, 241);
                        font-size: 16px;
                        font-weight: bold;
                        color: rgb(51, 51, 51);
                      "
                    >
                      <div class="cell">合作保险机构名称</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_40_column_159 is-center is-leaf"
                      style="
                        background-color: rgb(241, 241, 241);
                        font-size: 16px;
                        font-weight: bold;
                        color: rgb(51, 51, 51);
                      "
                    >
                      <div class="cell">业务合作范围</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_40_column_160 is-center is-leaf"
                      style="
                        background-color: rgb(241, 241, 241);
                        font-size: 16px;
                        font-weight: bold;
                        color: rgb(51, 51, 51);
                      "
                    >
                      <div class="cell">业务合作期限</div>
                    </th>
                    <th class="gutter" style="width: 0px; display: none"></th>
                  </tr>
                </thead>
              </table>
            </div>
            <div class="el-table__body-wrapper is-scrolling-none">
              <table
                cellspacing="0"
                cellpadding="0"
                border="0"
                class="el-table__body"
                style="width: 994px"
              >
                <colgroup>
                  <col name="el-table_40_column_155" width="80" />
                  <col name="el-table_40_column_157" width="230" />
                  <col name="el-table_40_column_158" width="228" />
                  <col name="el-table_40_column_159" width="228" />
                  <col name="el-table_40_column_160" width="228" />
                </colgroup>
                <tbody>
                  <tr class="el-table__row">
                    <td
                      rowspan="14"
                      colspan="1"
                      class="el-table_40_column_155 is-center"
                    >
                      <div class="cell">1</div>
                    </td>
                    <td
                      rowspan="14"
                      colspan="1"
                      class="el-table_40_column_157 is-center"
                    >
                      <div class="cell">
                        <div  style="display: inline-block">
                          <span >中智安心服务 微信公众号</span>
                          <!---->
                          <!---->
                          <!---->
                          <!---->
                        </div>
                      </div>
                    </td>
                    <td
                      rowspan="1"
                      colspan="1"
                      class="el-table_40_column_158 is-center"
                    >
                      <div class="cell">
                        <div  style="display: inline-block">
                          <span>众安在线财产保险股份有限公司</span>
                          <!---->
                          <!---->
                          <!---->
                          <!---->
                        </div>
                      </div>
                    </td>
                    <td
                      rowspan="1"
                      colspan="1"
                      class="el-table_40_column_159 is-center"
                    >
                      <div class="cell">
                        <div  style="display: inline-block">
                          <span >众无忧·众安家庭意外险</span><br/>
                          <span >孝欣保中老年人综合意外（3号）</span><br/>
                          <span >众民保·重疾险</span><br/>
                          <span >众民保·复发险</span><br/>
                          <span >尊享e生·重疾险</span><br/>
                          <span >尊享e生·百万医疗保险2026版</span><br/>
                          <span >尊享e生·中高端医疗保险2025版</span><br/>
                          <span >尊享e生·中高端医疗保险PLUS（2025版）</span><br/>
                          <span >众民保·中高端医疗险2026</span><br/>
                          <span >众民保·百万医疗险2025</span><br/>
                          <span >尊享宝贝·少儿高端医疗险2026版</span>
                          <!---->
                          <!---->
                          <!---->
                          <!---->
                        </div>
                      </div>
                    </td>
                    <td
                      rowspan="1"
                      colspan="1"
                      class="el-table_40_column_160 is-center"
                    >
                      <div class="cell">
                        <div  style="display: inline-block">
                          <span >2025年11月20日 -2028年11月19日</span>
                          <!---->
                          <!---->
                          <!---->
                          <!---->
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="el-table__row">
                    <td
                      rowspan="1"
                      colspan="1"
                      class="el-table_40_column_158 is-center"
                    >
                      <div class="cell">
                        <div  style="display: inline-block">
                           <span>中华联合财产保险股份有限公司</span>
                          <!---->
                          <!---->
                          <!---->
                          <!---->
                        </div>
                      </div>
                    </td>
                    <td
                      rowspan="1"
                      colspan="1"
                      class="el-table_40_column_159 is-center"
                    >
                      <div class="cell">
                        <div  style="display: inline-block">
                          <span >互联网门诊药品计划一</span><br />
						  <span >互联网门诊药品计划二</span><br />
						  <span >互联网门诊药品计划三</span>
                          <!---->
                          <!---->
                          <!---->
                          <!---->
                        </div>
                      </div>
                    </td>
                    <td
                      rowspan="1"
                      colspan="1"
                      class="el-table_40_column_160 is-center"
                    >
                      <div class="cell">
                        <div  style="display: inline-block">
                          <span >2025年12月04日-2028年12月03日</span>
                          <!---->
                          <!---->
                          <!---->
                          <!---->
                        </div>
                      </div>
                    </td>
                  </tr>

                  <!---->
                </tbody>
              </table>
              <!----><!---->
            </div>
            <!----><!----><!----><!---->
            <div
              class="el-table__column-resize-proxy"
              style="display: none"
            ></div>
          </div>
        </div>
      </div>

      <!--内容结束-->
    </div>
  </div>
</template>

<script>
export default {
  name: "InsuranceCompanyCooperation",
  components: {},
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style scoped lang="less">
@import "./../assets/table";
</style>



// WEBPACK FOOTER //
// src/pages/insuranceCompanyCooperation.vue